import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between p-4 border-b border-primary-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-heading font-semibold text-primary-800" }, " Upload Photo ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "p-6" }
const _hoisted_6 = ["onDrop"]
const _hoisted_7 = {
  key: 0,
  class: "relative"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col items-center text-center p-6\"><div class=\"w-12 h-12 mb-3 rounded-full bg-accent-100 flex items-center justify-center\"><svg class=\"w-6 h-6 text-accent-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z\"></path></svg></div><p class=\"text-sm font-medium text-primary-700 mb-1\"> Drop your photo here, or <span class=\"text-accent-600\">browse</span></p><p class=\"text-xs text-primary-400\">PNG, JPG up to 10MB</p></div>", 1)
const _hoisted_12 = { class: "mb-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-primary-700 mb-2" }, [
  /*#__PURE__*/_createTextVNode(" Add Tags "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-primary-400 font-normal" }, "(helps organize photos)")
], -1)
const _hoisted_14 = { class: "flex gap-2 mb-3" }
const _hoisted_15 = { class: "relative flex-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "absolute left-3 top-1/2 -translate-y-1/2 text-primary-400" }, " # ", -1)
const _hoisted_17 = ["onKeyup"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-3 h-3",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "text-xs text-primary-400"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "w-5 h-5 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  class: "text-xs text-center text-primary-400 mt-3"
}

import { ref, computed } from "vue";
import { HoodApi } from "@/services/HoodApi";

interface Tag {
  id?: number;
  text: string;
}


export default /*#__PURE__*/_defineComponent({
  emits: ["upload_complete", "close"],
  setup(__props, { emit }) {



const fileInput = ref<HTMLInputElement | null>(null);
const selectedFile = ref<File | null>(null);
const previewUrl = ref<string | null>(null);
const tags = ref<Tag[]>([]);
const newTag = ref("");
const working = ref(false);
const isDragging = ref(false);

const canUpload = computed(() => selectedFile.value !== null);

const handleFileSelect = (event: Event) => {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files[0]) {
    setFile(input.files[0]);
  }
};

const handleDrop = (event: DragEvent) => {
  isDragging.value = false;
  const files = event.dataTransfer?.files;
  if (files && files[0] && files[0].type.startsWith("image/")) {
    setFile(files[0]);
  }
};

const setFile = (file: File) => {
  selectedFile.value = file;
  previewUrl.value = URL.createObjectURL(file);
};

const clearPhoto = () => {
  selectedFile.value = null;
  previewUrl.value = null;
  if (fileInput.value) {
    fileInput.value.value = "";
  }
};

const addTag = () => {
  const tagText = newTag.value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
  if (tagText && !tags.value.some((t) => t.text === tagText)) {
    tags.value.push({ text: tagText });
  }
  newTag.value = "";
};

const removeTag = (index: number) => {
  tags.value.splice(index, 1);
};

const upload = async () => {
  if (!selectedFile.value) return;

  const formData = new FormData();
  formData.append("file", selectedFile.value);
  formData.append("tag", JSON.stringify(tags.value));

  working.value = true;
  try {
    const response = await HoodApi.upload_photo(formData);
    emit("upload_complete", response);
    // Reset form
    clearPhoto();
    tags.value = [];
  } catch (e) {
    console.error("Upload failed:", e);
  } finally {
    working.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
        class: "p-2 text-primary-400 hover:text-primary-600 hover:bg-primary-100 rounded-lg transition-colors"
      }, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "relative mb-6",
        onDragover: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isDragging.value = true), ["prevent"])),
        onDragleave: _cache[2] || (_cache[2] = ($event: any) => (isDragging.value = false)),
        onDrop: _withModifiers(handleDrop, ["prevent"])
      }, [
        (previewUrl.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("img", {
                src: previewUrl.value,
                alt: "Preview",
                class: "w-full h-64 object-cover rounded-xl"
              }, null, 8, _hoisted_8),
              _createElementVNode("button", {
                onClick: clearPhoto,
                class: "absolute top-2 right-2 p-2 bg-black/50 text-white rounded-full hover:bg-black/70 transition-colors"
              }, _hoisted_10)
            ]))
          : (_openBlock(), _createElementBlock("label", {
              key: 1,
              class: _normalizeClass(["flex flex-col items-center justify-center h-48 border-2 border-dashed rounded-xl cursor-pointer transition-colors", 
            isDragging.value
              ? 'border-accent-500 bg-accent-50'
              : 'border-primary-200 hover:border-primary-300 bg-primary-50'
          ])
            }, [
              _hoisted_11,
              _createElementVNode("input", {
                type: "file",
                class: "hidden",
                accept: "image/*",
                ref_key: "fileInput",
                ref: fileInput,
                onChange: handleFileSelect
              }, null, 544)
            ], 2))
      ], 40, _hoisted_6),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newTag).value = $event)),
              type: "text",
              placeholder: "blockparty2024, doggos...",
              class: "w-full pl-7 pr-4 py-2 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors text-sm",
              onKeyup: _withKeys(addTag, ["enter"])
            }, null, 40, _hoisted_17), [
              [_vModelText, newTag.value]
            ])
          ]),
          _createElementVNode("button", {
            onClick: addTag,
            disabled: !newTag.value.trim(),
            class: "px-4 py-2 bg-primary-100 text-primary-700 font-medium rounded-lg hover:bg-primary-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          }, " Add ", 8, _hoisted_18)
        ]),
        (tags.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index,
                  class: "inline-flex items-center gap-1 px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-sm font-medium"
                }, [
                  _createTextVNode(" #" + _toDisplayString(tag.text) + " ", 1),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (removeTag(index)),
                    class: "p-0.5 hover:bg-accent-200 rounded-full transition-colors"
                  }, _hoisted_22, 8, _hoisted_20)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_23, " Press Enter or click Add to add a tag "))
      ]),
      _createElementVNode("button", {
        onClick: upload,
        disabled: !_unref(canUpload) || working.value,
        class: "w-full flex items-center justify-center gap-2 px-4 py-3 bg-accent-600 text-white font-medium rounded-xl hover:bg-accent-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      }, [
        (working.value)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_28))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(working.value ? "Uploading..." : "Upload Photo"), 1)
      ], 8, _hoisted_24),
      (!previewUrl.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_29, " Select a photo to upload "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})